var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eventsearch" }, [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-80 md-medium-size-80 md-small-size-80 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            { staticClass: "md-alignment-top-center md-elevation-1" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "searchbar" }, [
                  _c("h1", { staticClass: "searchbar__headline" }, [
                    _vm._v("Suche nach Veranstaltungen:")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "searchbar__input-wrapper" },
                    [
                      _c("v-text-field", {
                        staticClass: "searchbar__input",
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Suchbegriff eingeben",
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.searchterm,
                          callback: function($$v) {
                            _vm.searchterm = $$v
                          },
                          expression: "searchterm"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "detail-dropdown" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "detail-dropdown__label",
                              staticStyle: { opacity: "0.7" },
                              attrs: { align: "left" }
                            },
                            [_vm._v("Detailsuche")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-card-expand-trigger",
                            { staticClass: "detail-dropdown__button" },
                            [
                              _c(
                                "md-button",
                                { staticClass: "md-icon-button md-dense" },
                                [
                                  _c("md-icon", [_vm._v("keyboard_arrow_down")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _c(
                    "md-card-expand",
                    [
                      _c(
                        "md-card-expand-content",
                        [
                          _c(
                            "md-card-content",
                            [
                              _vm._l(_vm.selectedtopics, function(topic) {
                                return _c(
                                  "md-chip",
                                  {
                                    key: topic.index,
                                    staticClass: "md-accent dist",
                                    attrs: { "md-deletable": "" },
                                    on: {
                                      "md-delete": function($event) {
                                        return _vm.removeTopic(topic)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(topic))]
                                )
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.selectedsectors, function(sector) {
                                return _c(
                                  "md-chip",
                                  {
                                    key: sector.text,
                                    staticClass: "md-primary dist",
                                    attrs: { "md-deletable": "" },
                                    on: {
                                      "md-delete": function($event) {
                                        return _vm.removeSector(sector)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(sector))]
                                )
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.selectedprocesses, function(process) {
                                return _c(
                                  "md-chip",
                                  {
                                    key: process.text,
                                    staticClass: "md-accent dist",
                                    attrs: { "md-deletable": "" },
                                    on: {
                                      "md-delete": function($event) {
                                        return _vm.removeProcess(process)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(process))]
                                )
                              }),
                              _vm._v(" "),
                              _vm.selectedsize != null &&
                              _vm.selectedsize != "Alle"
                                ? _c(
                                    "md-chip",
                                    {
                                      staticClass: "md-accent dist",
                                      attrs: { "md-deletable": "" },
                                      on: {
                                        "md-delete": function($event) {
                                          _vm.selectedsize = "Alle"
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.selectedsize))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.range != "" && _vm.plz.length == 5
                                ? _c(
                                    "md-chip",
                                    {
                                      staticClass: "md-accent dist",
                                      attrs: { "md-deletable": "" },
                                      on: {
                                        "md-delete": function($event) {
                                          _vm.range = ""
                                          _vm.plz = null
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Umkreis von " +
                                          _vm._s(_vm.range) +
                                          "km von " +
                                          _vm._s(_vm.plz)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "md-layout md-gutter" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "topic" } },
                                              [_vm._v("Themen")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  placeholder: "Themen",
                                                  name: "topic",
                                                  id: "topic",
                                                  "md-dense": "",
                                                  multiple: ""
                                                },
                                                model: {
                                                  value: _vm.selectedtopics,
                                                  callback: function($$v) {
                                                    _vm.selectedtopics = $$v
                                                  },
                                                  expression: "selectedtopics"
                                                }
                                              },
                                              _vm._l(_vm.topics, function(
                                                topic
                                              ) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: topic.index,
                                                    attrs: { value: topic.text }
                                                  },
                                                  [_vm._v(_vm._s(topic.text))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "sector" } },
                                              [_vm._v("Branchen")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "sector",
                                                  id: "sector",
                                                  "md-dense": "",
                                                  multiple: ""
                                                },
                                                model: {
                                                  value: _vm.selectedsectors,
                                                  callback: function($$v) {
                                                    _vm.selectedsectors = $$v
                                                  },
                                                  expression: "selectedsectors"
                                                }
                                              },
                                              _vm._l(_vm.sectors, function(
                                                sector
                                              ) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: sector.text,
                                                    attrs: {
                                                      value: sector.text
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(sector.text))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "md-layout md-gutter" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "process" } },
                                              [_vm._v("Prozesse")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "process",
                                                  id: "process",
                                                  "md-dense": "",
                                                  multiple: ""
                                                },
                                                model: {
                                                  value: _vm.selectedprocesses,
                                                  callback: function($$v) {
                                                    _vm.selectedprocesses = $$v
                                                  },
                                                  expression:
                                                    "selectedprocesses"
                                                }
                                              },
                                              _vm._l(_vm.processes, function(
                                                process
                                              ) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: process.text,
                                                    attrs: {
                                                      value: process.text
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(process.text))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "size" } },
                                              [_vm._v("Unternehmensgröße")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "size",
                                                  id: "size",
                                                  "md-dense": ""
                                                },
                                                model: {
                                                  value: _vm.selectedsize,
                                                  callback: function($$v) {
                                                    _vm.selectedsize = $$v
                                                  },
                                                  expression: "selectedsize"
                                                }
                                              },
                                              _vm._l(_vm.sizes, function(size) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: size.text,
                                                    attrs: { value: size.text }
                                                  },
                                                  [_vm._v(_vm._s(size.text))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "md-layout md-gutter" },
                                  [
                                    _c("p", { staticClass: "dist" }, [
                                      _vm._v("Umkreissuche")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "md-layout md-gutter" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c("label", [
                                              _vm._v("Postleitzahl")
                                            ]),
                                            _vm._v(" "),
                                            _c("md-input", {
                                              model: {
                                                value: _vm.plz,
                                                callback: function($$v) {
                                                  _vm.plz = $$v
                                                },
                                                expression: "plz"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "range" } },
                                              [_vm._v("Umkreis")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "range",
                                                  id: "range",
                                                  "md-dense": ""
                                                },
                                                model: {
                                                  value: _vm.range,
                                                  callback: function($$v) {
                                                    _vm.range = $$v
                                                  },
                                                  expression: "range"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "50" } },
                                                  [_vm._v("50km")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "100" } },
                                                  [_vm._v("100km")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "200" } },
                                                  [_vm._v("200km")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "300" } },
                                                  [_vm._v("300km")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "1000" } },
                                                  [_vm._v("Unbeschränkt")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout md-gutter md-alignment-top-right"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "md-layout-item" },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass: "md-raised md-accent",
                                            on: {
                                              click: function($event) {
                                                return _vm.resetFilters()
                                              }
                                            }
                                          },
                                          [_vm._v("Zurücksetzen")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "md-layout-item"
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "md-layout-item md-alignment-top-right"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout-item md-alignment-top-right"
                                      },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass: "md-raised md-primary",
                                            on: {
                                              click: function($event) {
                                                return _vm.applyFilters()
                                              }
                                            }
                                          },
                                          [_vm._v("Anwenden")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "loading",
                  staticStyle: { "margin-top": "50px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout md-gutter md-alignment-center-center"
                    },
                    [
                      _c("md-progress-spinner", {
                        attrs: {
                          "md-diameter": 50,
                          "md-stroke": 5,
                          "md-mode": "indeterminate"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading &&
          (_vm.events.length == 0 || _vm.searchresults.length == 0)
            ? _c("div", [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.searchresults, function(item) {
            return _c(
              "div",
              { key: item.hash },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-link",
                    attrs: {
                      to: { name: "EventDetail", params: { hash: item.hash } }
                    }
                  },
                  [
                    _c(
                      "md-card",
                      {
                        staticClass:
                          "margin-twenty md-alignment-top-center md-elevation-1",
                        attrs: { "md-with-hover": "" }
                      },
                      [
                        _c(
                          "md-card-header",
                          { staticClass: "md-title" },
                          [
                            _c("md-card-header-text", [
                              _vm._v(_vm._s(item.name))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("md-card-content", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout md-gutter md-alignment-center-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-30 md-medium-size-20 md-small-size-100 md-xsmall-size-100"
                                },
                                [
                                  item.image != "undefined"
                                    ? _c("img", {
                                        attrs: {
                                          "item.image": "",
                                          src: "" + item.imgLink
                                        }
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-70 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                        },
                                        [
                                          _c("b", [_vm._v("Kategorie:")]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(item.category)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Termin:")]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(item.eventdate)
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                        },
                                        [
                                          _c("b", [_vm._v("Ort:")]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(item.place)
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "md-layout md-gutter md-alignment-center-center",
        staticStyle: { "margin-top": "10px" }
      },
      [_c("h3", [_vm._v("Keine passenden Ergebnisse gefunden")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bd96c57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd96c57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/eventsearch/query/EventSearch.vue
// module id = null
// module chunks = 